<template>
  <div class="cb-setup-test-1">
    <div class="cb-setup-test-1__body">
      <h1 class="cb-heading-4" tabindex="-1" ref="title">Arm your system</h1>
      <p v-if="testFailed" class="cb-body-1">
        Now that your system is in test mode, it’s time to arm your system. Once
        you do that, continue to Step 3.
      </p>
      <p v-else class="cb-body-1">
        Now it’s time to arm your system. Once you have armed it, continue to Step 3.
      </p>
    </div>
    <div class="cb-setup-test-1__footer">
      <div class="cb-setup-test-1__footer__divider"></div>
      <div class="cb-setup-test-1__footer__button-container">
        <button @click="handleGoBack" class="cb-button cb-button--outline-blue">
          Go Back
        </button>
        <button
          @click="handleGoBack"
          aria-label="Go Back"
          class="cb-setup-test-1__footer__back-button"
        >
          <img
            alt
            src="../assets/icons/back-arrow.svg"
          />
        </button>
        <button @click="handleNextStep" class="cb-button cb-button--blue">
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      testFailed: (state) => state.testFailed,
    }),
  },
  mounted() {
    this.$refs.title.focus();
    document.title = 'CellBridge - Arm your system';
  },
  methods: {
    handleGoBack() {
      this.updateManualTestStep('1');
      gtag('event', 'backClick', {
        event_label: 'go back',
        event_category: 'step2',
        value: 1,
      });
    },
    handleNextStep() {
      this.updateManualTestStep('3');
      gtag('event', 'continueClick', {
        event_label: 'continue',
        event_category: 'step2',
        value: 1,
      });
    },
    ...mapActions(['updateSetupTestStep']),
    ...mapMutations(['updateManualTestStep']),
  },
};
</script>

<style lang="scss" scoped>
.cb-setup-test-1 {
  &__body {
    .cb-heading-4 {
      margin-bottom: 12px;
    }

    .cb-body-1 {
      margin-bottom: 28px;
    }
  }

  &__footer {
    margin-top: 40px;

    .cb-button {
      width: 100%;

      &--outline-blue {
        display: none;
      }
    }

    &__back-button {
      border: none;
      background-color: unset;
      position: absolute;
      top: 20px;
      left: 20px;
      padding: 0;
    }
  }

  @include desktop {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    &__body {
      flex-grow: 1;
      padding: 0 40px;

      .cb-heading-4 {
        font-size: 36px;
        line-height: 50px;
      }
    }

    &__footer {
      margin-top: 0;

      &__divider {
        display: block;
        height: 1px;
        background-color: $light-blue-grey;
        margin-bottom: 20px;
      }

      &__button-container {
        display: flex;
        justify-content: flex-end;

        .cb-button {
          width: auto;

          &--outline-blue {
            display: block;
            margin-right: 16px;
          }
        }
      }

      &__back-button {
        display: none;
      }
    }
  }
}
</style>
